import rootReducer, {RootState} from "./reducers/rootState";
import thunk from "redux-thunk";
import {applyMiddleware, createStore, Store, compose} from "redux";
import logger from "redux-logger";
import { composeWithDevTools } from 'redux-devtools-extension';

const middleware = [thunk]

export default createStore(rootReducer, composeWithDevTools(applyMiddleware(...middleware))) as Store<RootState>;
